import * as tesouraria from './store'

export function tesourariaModule({ store }) {
  store.registerModule('tesouraria', { ...tesouraria, namespaced: true })
}
